import Graphic from '@arcgis/core/Graphic';
import TextSymbol from '@arcgis/core/symbols/TextSymbol';
import { JepGraphicsLayer } from '@jeppesen-foreflight/jmkw-types';

export const LOCATION_LAYER = new JepGraphicsLayer({
  id: 'location',
  label: 'Location',
  zOrder: 101,
  graphics: [
    new Graphic({
      symbol: new TextSymbol({
        color: '#7C009F',
        text: '\ue61d',
        font: {
          size: 21,
          family: 'CalciteWebCoreIcons'
        }
      })
    })
  ]
});
